var map = {
	"./blog.yml": 125,
	"./cloud.yml": 126,
	"./color.yml": 127,
	"./country.yml": 128,
	"./dio.yml": 129,
	"./doc.yml": 130,
	"./emoji.yml": 131,
	"./git.yml": 132,
	"./icon.yml": 133,
	"./license.yml": 134,
	"./link.yml": 135,
	"./metrics.yml": 136,
	"./people.yml": 137,
	"./soft.yml": 138,
	"./src.yml": 139,
	"./status.yml": 140
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 124;